import request from './request'

const isProd = process.env.NODE_ENV === 'production'

const { origin } = window.location
// const serveUrl = 'https://infosecapi.pt.xiaomi.com'
let serveUrl = `${origin}/infosecapi/`
// 联调环境地址
if (!isProd) {
  serveUrl = 'https://daily.privacy.mi.com/infosecapi'
  // serveUrl = 'http://mock.be.mi.com/mock/644'
}

export function getAnouncements(page, size, lang) {
  return request({
    options: { headers: { Authorization: 'Bearer 5e8c647361ecd1f2d7a334c1a9dfa1b1' } },
    url: `${serveUrl}/inner/infosec/bugNotice/list`,
    query: {
      page,
      pageSize: size,
      language: lang,
    },
  })
}

export function searchAnouncements(value, lang) {
  return request({
    options: { headers: { Authorization: 'Bearer 5e8c647361ecd1f2d7a334c1a9dfa1b1' } },
    url: `${serveUrl}/inner/infosec/bugNotice/list`,
    query: {
      title: value,
      language: lang,
    },
  })
}

export function getDetail(id, lang) {
  return request({
    options: { headers: { Authorization: 'Bearer 5e8c647361ecd1f2d7a334c1a9dfa1b1' } },
    url: `${serveUrl}/inner/infosec/bugNotice/details`,
    query: {
      id,
      language: lang,
    },
  })
}
